import { AbstractControl, ValidatorFn } from "@angular/forms";
import validator from "validator";

import { VALIDATION_PASSED, ValidationErrorKey } from "./general-validation.";

/**
 * The validation for the e-mail address is done with the same library as our backend is using.
 *
 * Note: To avoid any inconsistencies we should make sure to reference the same major version.
 *
 * Backend Version: ^13.9.0 (https://github.com/typestack/class-validator/blob/develop/package.json#L41)
 */
export const emailAddressValidator: ValidatorFn = (
  control: AbstractControl<string, string>,
) => {
  if (!control.value) {
    return VALIDATION_PASSED;
  }

  return validator.isEmail(control.value)
    ? VALIDATION_PASSED
    : { [ValidationErrorKey.EMAIL]: true };
};
